import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import Helpers from "../../../../utils/helpers";

const GridPanel = (props: any) => {
  const { getUser, textForLDR, filteredItems } = props;
  var navigate = useNavigate();
  const [gridDatas, setGridDatas] = useState<any[]>([]);
  const responsiveOptions = [
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "991px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  useEffect(() => {
    if (filteredItems && filteredItems.length > 0) {
      setGridDatas(filteredItems);
    }
  }, [filteredItems]);

  const handleEdit = (id: any) => {
    if (getUser?.superAdmin == false && getUser?.globalAdmin == false) {
      if (textForLDR == "Company Name") {
        return <></>;
      } else {
        return (
          <div className="dropdown">
            <span
              className="material-symbols-outlined"
              style={{ cursor: "pointer" }}
              onClick={() => {
                navigate(`/aura-camera/sites-creation/${id}`);
              }}
            >
              edit
            </span>
          </div>
        );
      }
    } else {
      return <></>;
    }
  };

  const productTemplate = (gridData: any) => {
    return (
      <>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="card panel-box">
            <div className="card-header">
              <h6>{gridData.siteName}</h6>
              {handleEdit(gridData._id)}
            </div>
            <div className="card-body">
              <ol>
                <li>
                  <div className="list-title">{textForLDR}</div>
                  <div className="list-value">{gridData?.companyName}</div>
                </li>
                <li>
                  <div className="list-title">Location</div>
                  <div className="list-value">
                    {gridData?.state},&nbsp;{gridData?.city},&nbsp;
                    {gridData?.zip}
                  </div>
                </li>
                <li>
                  <div className="list-title">Site Contact Name</div>
                  <div className="list-value">{gridData?.contactName}</div>
                </li>
                <li>
                  <div className="list-title">Phone</div>
                  <div className="list-value">{gridData?.phone}</div>
                </li>
                <li>
                  <div className="list-title">Notes</div>
                  <div className="list-value">{gridData?.notes}</div>
                </li>
                <li>
                  <div className="list-title">Status</div>
                  <div className="list-value">
                    {gridData?.status == "true" ? "Active" : "Inactive"}
                  </div>
                </li>
                {/*  <li>
                  <div className="list-title">Date</div>
                  <div className="list-value">
                    {Helpers.ConvertUtcToLocalReadable(gridData?.createdOn)}
                  </div>
                </li> */}
              </ol>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <Carousel
        value={gridDatas}
        numVisible={3}
        numScroll={1}
        responsiveOptions={responsiveOptions}
        itemTemplate={productTemplate}
      />
    </>
  );
};

export default GridPanel;
